import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HomeDataProvider } from "../../database/HomeDataContext";
import Navbar from "../../Components/NavBar/index";
import Hero from "../../Components/Hero/index";
import Body2 from "../../Components/Home-new/Body2/index";
import Body3 from "../../Components/Home-new/Body3/index";
import Body4 from "../../Components/Home-new/Body4/index";
import Body5 from "../../Components/Home-new/Body5/index";
import Body7 from "../../Components/Home-new/Body7/index";
import Body8 from "../../Components/Home-new/Body8/index";
import Body9 from "../../Components/Home-new/Body9/index";
import Footer from "../../Components/Footer/index";
import SEO from "../../Components/SEO/index";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state && location.state.scrollTo === 'how-it-works') {
      // Add a delay to ensure components and initial layout are fully rendered
      setTimeout(() => {
        const element = document.getElementById('how-it-works');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });

          // Clear the state after scrolling so it doesn't happen on reload,
          // delayed to prevent interrupting the smooth scroll animation
          setTimeout(() => {
            navigate(location.pathname, { replace: true, state: { preventScrollReset: true } });
          }, 1000);
        }
      }, 300);
    }
  }, [location, navigate]);

  return (
    <HomeDataProvider>
      <SEO pageName="home" />
      <Navbar />
      <Hero />
      <Body2 />
      <Body5 />
      <Body3 />
      <Body4 />
      <Body7 />
      <Body8 />
      <Body9 />
      <Footer />
    </HomeDataProvider>
  );
};

export default Home;